import React from 'react';
import { Button } from './ui/button';
import { SortAsc, Grid3X3, Palette } from 'lucide-react';

export type SortingOption = 'none' | 'alphabetical' | 'forge' | 'color';

interface ElementSortingControlProps {
  currentSorting: SortingOption;
  onSortingChange: (option: SortingOption) => void;
}

const ElementSortingControl: React.FC<ElementSortingControlProps> = ({
  currentSorting,
  onSortingChange,
}) => {
  return (
    <div className="flex items-center gap-1 mb-2">
      <span className="text-xs text-muted-foreground mr-1">Sort:</span>
      <Button
        variant={currentSorting === 'none' ? 'default' : 'outline'}
        size="sm"
        className="h-7 px-2 text-xs transition-none"
        onClick={() => onSortingChange('none')}
        title="No sorting (default order)"
      >
        <Grid3X3 className="h-3 w-3 mr-1" />
        None
      </Button>
      <Button
        variant={currentSorting === 'alphabetical' ? 'default' : 'outline'}
        size="sm"
        className="h-7 px-2 text-xs transition-none"
        onClick={() => onSortingChange('alphabetical')}
        title="Sort alphabetically"
      >
        <SortAsc className="h-3 w-3 mr-1" />
        A-Z
      </Button>
      <Button
        variant={currentSorting === 'forge' ? 'default' : 'outline'}
        size="sm"
        className="h-7 px-2 text-xs transition-none"
        onClick={() => onSortingChange('forge')}
        title="Sort by forge type"
      >
        <Grid3X3 className="h-3 w-3 mr-1" />
        Forge
      </Button>
      <Button
        variant={currentSorting === 'color' ? 'default' : 'outline'}
        size="sm"
        className="h-7 px-2 text-xs transition-none"
        onClick={() => onSortingChange('color')}
        title="Sort by color"
      >
        <Palette className="h-3 w-3 mr-1" />
        Color
      </Button>
    </div>
  );
};

export default ElementSortingControl;
